import type { RefObject } from "react";

import { useEventListener } from "./useEventListener";

export const useOnClickOutside = (
  refs: Array<RefObject<Element>> | RefObject<Element>,
  handler: (event: MouseEvent) => void,
  mouseEvent: "mousedown" | "mouseup" = "mousedown",
): void => {
  const refArray = Array.isArray(refs) ? refs : [refs];

  useEventListener(mouseEvent, (event) => {
    const isClickInside = refArray.some((ref) => {
      const el = ref?.current;
      return el?.contains(event.target as Node);
    });

    if (!isClickInside) {
      handler(event);
    }
  });
};
